import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import { useAuth } from "@/lib/auth";
import { PropertyProvider, useProperty } from "@/lib/property";
import { PermissionProvider } from "@/lib/permissions";

function Shell() {
  const { activeId } = useProperty();
  return (
    <div className="min-h-screen md:flex bg-background">
      <Sidebar />
      <main className="flex-1 min-w-0 md:h-screen md:overflow-y-auto">
        <div className="p-4 md:p-8 max-w-[1600px] mx-auto">
          <Outlet key={activeId || "none"} />
        </div>
      </main>
    </div>
  );
}

export default function Layout() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center label-overline">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;

  return (
    <PropertyProvider>
      <PermissionProvider>
        <Shell />
      </PermissionProvider>
    </PropertyProvider>
  );
}
